import React from "react";

const Blogs = () => {
  return (
    <div
      className="container mx-auto "
      style={{ minHeight: "calc(100vh - 6.5rem)" }}
    >
      <div className="mt-36">
        <h1 className="text-3xl font-bold text-center">Cooming Soon..</h1>
      </div>
    </div>
  );
};

export default Blogs;
